export default {
    Checking: 0,
    Confirmed: 1,
    Error: 2
}
